import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ChatbotServiceService } from '../headquarter/service/chatbot-service.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-chatbot-component',
  templateUrl: './chatbot-component.component.html',
  styleUrls: ['./chatbot-component.component.scss']
})
export class ChatbotComponentComponent implements OnInit {
  title = 'FCI_angular';
  image_URL: any = environment.image_URL;
  // FILE_PATH: any = environment.FILE_PATH;
  text: any = '';
  showChatbot: boolean = false;
  botMsg: any = '';
  userMsg: any = '';
  botObj: any = [];
  scrollEle: any;
  today: any;
  winWidth: any;
  feedbackForm: any = false;
  readMoreStatus: any = true;
  placeholder: any = '';
  inputType: any = 'text';
  typing: number = 0;
  minimized: any = false;
  fabChatbtn: boolean = false;
  newBotMsg: any = ""
  accrdReadStatus: any[] = []
  onlyfaq: any = false
  botMsg1: any
  faqExpandId: any
  feedName: any = '';
  feedbackVal: any = ''
  reqType: any = '';
  otpVal: any = '';
  mblVal: any = '';
  mblStatus: any = 'mbl';
  passList: any[] = [];
  createdBy: any = '';
  faqData: any[] = []
  matchedFaq: any[] = []
  serviceVal: any = ""
  componentVal: any[] = []
  textVal: any = ""
  language:any = '';
  dbData:any
  toggleVal:any = 'English' //hindi
  @ViewChild('queryInput', { static: false }) queryInput: ElementRef | undefined;
  // @ViewChild('gSearch') formSearch: any
  // @ViewChild('searchKey') hiddenSerachHandler: any
  constructor(private service: ChatbotServiceService, public ref: ChangeDetectorRef,public translate: TranslateService) { }

  ngOnInit(): void {
    if (sessionStorage.getItem('locale')) {
      this.toggleVal ='English' //sessionStorage.getItem('locale')
    }
    else {

      this.toggleVal = 'English' //hindi
    }
    this.service.getDBData().subscribe((res: any) => {
      this.dbData = res.data
    })
    this.scrollEle = document.getElementById('chat_room');
    this.today = new Date();
    this.winWidth = window.innerWidth;
  }

  scroll_ele() {
    if (this.readMoreStatus) {
      this.scrollEle.scrollTop = this.scrollEle.scrollHeight;
    }
  }


  // scroll_ele() {
  //   // console.log(this.readMoreStatus)
  //   // console.log('scroll_ele');

  //   if (this.readMoreStatus) {
  //     this.scrollEle.scrollTop = this.scrollEle.scrollHeight;
  //     // this.temp = this.scrollEle.scrollTop
  //     // console.log(this.scrollEle.scrollTop)
  //   }
  // }

  callBot() {
    this.readMoreStatus = true;
    this.typing = 1;

    if (localStorage.getItem("chatHistory")) {
      this.typing = 0;
    }
    else {
      this.botObj = [];
      this.placeholder = "अपनी सवाल यहां लिखें..."
      if(this.toggleVal == 'Hindi'){
        var textObj = {
          "intent": 'hi_hindi',
          "type": this.toggleVal
        };
      }
      else{
        this.placeholder = "Enter your query here..."
        var textObj = {
          "intent": 'hi',
          "type": this.toggleVal
        };
      }
      this.service.getChatbotInformation(textObj).subscribe((res: any) => {
        this.botMsg = res
        this.typing = 0;
        var that = this
        this.readMoreStatus = true;
        for (let i = 1; i < 3; i++) {
          setTimeout(function () {
            if (i == 1) {
              if(that.toggleVal == 'Hindi'){
                that.callBotWelcome('w1_hindi')
              }
              else{
                that.callBotWelcome('w1')
              }
            }
          }, 2000)
        }

        this.checkCondition(res)
      })
    }
  }
  callBotWelcome(intentType: any) {

    if (localStorage.getItem("chatHistory")) {
      this.typing = 0;
    }
    else {
      var textObj = {
        "intent": intentType,
        "type": this.toggleVal
      };
      this.service.getChatbotInformation(textObj).subscribe((res: any) => {
        this.botMsg = res
        this.typing = 0;
        this.checkCondition(res)
      })
    }
  }

  newBotMsg1: any
  viewAns:any = ''
  checkCondition(res: any) {
    this.searchName = []
    this.newBotMsg = []
    let botMsg = res;
    if (botMsg.includes('~')) {
      this.newBotMsg1 = botMsg.split('~')
      if (this.newBotMsg1[0] == 'welcome') {
        let obj = { 'actionType': 'faq', 'msg': this.newBotMsg1[1], 'type': 'BR' };
        this.botObj.push(obj);
      }
    }
    else {
      this.newBotMsg = botMsg
      if (typeof botMsg == 'object') {
        if (this.userMsg.includes("?")) {
          var msgQuestion = this.userMsg.split("?")[0].toLowerCase().trim();
        }
        else {
          var msgQuestion = this.userMsg.toLowerCase()
        }

        const questionsWithoutQuestionMark = res.map((item:any) => item.msg.split('?')[0].toLowerCase());

        const similarityScores = questionsWithoutQuestionMark.map((question:any) => this.calculateSimilarity(msgQuestion.toLowerCase(), question.toLowerCase()));

        const maxSimilarity = Math.max(...similarityScores);
        const similarityPercentage = (maxSimilarity / msgQuestion.length) * 100;
        console.log(similarityPercentage)
        if(this.toggleVal == 'Hindi'){
          var minPercentage = 10
          var maxPercentage = 30
        }
        else{
          var minPercentage = 40
          var maxPercentage = 65
        }
        if (similarityPercentage >= minPercentage && similarityPercentage <= maxPercentage) {
          let obj = { 'actionType': 'viewAns', 'msg': res[0]['result'], 'type': 'BR' };
          this.botObj.push(obj);
          this.searchName = []
        }
        else {
          if (res.length > 1) {
            this.searchName = []
            let obj = { 'actionType': 'viewSugg', 'msg': res, 'type': 'BR' };
            this.botObj.push(obj);
          }
          else {
            this.searchName = []
            let obj = { 'actionType': 'viewAns', 'msg': res[0]['result'], 'type': 'BR' };
            this.botObj.push(obj);
          }
        }
        this.viewAns = 'viewAns'
        this.ref.detectChanges()
      }
      else {
        let obj = { 'actionType': 'selectSugg', 'msg': res, 'type': 'BR' };
        this.botObj.push(obj);
      }
    }
  }

  calculateSimilarity(a: string, b: string): number {
    const setA = new Set(a);
    const setB = new Set(b);

    const intersection = new Set([...setA].filter(char => setB.has(char)));
    return intersection.size;
  }

  faqArr: any[] = []
  query(query: any, checkType?: any) {
    this.searchName = []
    this.readMoreStatus = true;
    var that = this;
    this.userMsg = query
    if (checkType != 'hideUserMsg') {
      this.userMsg = query;
      var obj = { 'msg': this.userMsg, 'type': 'UR' };
      this.botObj.push(obj);
      if (that.queryInput != undefined) {
        that.queryInput.nativeElement.value = '';
        this.typing = 1;
        var textObj
      }
      if (query == "FAQ") {
        // this.getFAQ('chat-bot')
        textObj = {
          "intent": "faq",
          "type": this.toggleVal
        };
      }
      else {
        textObj = {
          "intent": query.toLowerCase(),
          "type": this.toggleVal
        };
      }
      this.service.getChatbotInformation(textObj).subscribe((res: any) => {
        this.botMsg = res;
        this.searchName = []
        this.typing = 0
        this.tempSearchName = []
        this.viewAns = 'viewAns'
        // this.readMoreStatus = false;
        this.checkCondition(res)
      })
    }
  }
  tempSearchName: any[] = []
  entClicked(e: any) {
    // alert(this.scrollEle)
    this.viewAns = ''
    this.searchName = []
    this.tempSearchName = []
    if (e.target['value']) {
      if (e.target['value'] == 'hi' || e.target['value'] == 'hello' || e.target['value'] == 'exit') {
        this.callBot()
        this.text = ''
      }
      else if (e.target['value'].toLowerCase().trim() == 'home' || e.target['value'].toLowerCase().trim() == 'start' || e.target['value'].toLowerCase().trim() == 'start/home' || e.target['value'].toLowerCase().trim() == 'home/start') {
        this.scrollEle.scrollTop = 0;
        e.target['value'] = '';
        this.ref.detectChanges();

      }
      else {
        this.text = ''
        this.query(e.target['value']);
      }
    }
  }

  searchName: any[] = []
  sendClicked(e: any) {
    this.viewAns = ''
    this.searchName = []
    var currObj = this
    if (this.text) {
      if (this.text == 'hi' || this.text == 'hello' || this.text == 'exit') {
        this.callBot()
      }
      else if (this.text.toLowerCase().trim() == 'home' || this.text.toLowerCase().trim() == 'start' || this.text.toLowerCase().trim() == 'start/home' || this.text.toLowerCase().trim() == 'home/start') {
        this.scrollEle.scrollTop = 0;
        this.text = '';
        this.ref.detectChanges();
      }
      else {
        // this.text = str1
        this.query(currObj.queryInput?.nativeElement.value);
      }
    }
    this.text = ''
    this.searchName = []
  }


  opensweetalert() {
    this.tempSearchName = []
    this.showChatbot == true;
    this.feedbackForm == false;
    this.showChatbot = !this.showChatbot;
  }

  showChatbotBtn() {
    this.fabChatbtn = true;
  }

  chatbotshow(e: any) {
    //  window.parent.document.body.style.backgroundColor='blue';
    //alert(btn);
    console.log(e)
    this.text = ''
    this.userMsg = ''
    this.showChatbot = !this.showChatbot;
  }
  scrollToTop() {
    window.scrollTo(0, 0);
  }

  isIdle = false;
  idleThreshold = 500;
  idleTimer: any;
  keyupClicked(e: any) {
    // this.clickFaq = false
    // this.service.setCondition(this.clickFaq);
    this.viewAns = ''
    var currObj = this;
    if (e.target.value.length >= 3) {
      if (e.target.value.toLowerCase().trim() != 'home' && e.target.value.toLowerCase().trim() != 'start') {
        let textObj = {
          "intent": e.target.value.toLowerCase(),
          "type": this.toggleVal
        };
        this.resetIdleTimer(textObj);
      }
    }
    else {
      this.searchName = []
    }
  }

  resetIdleTimer(data?:any) {
    // Clear any previous idle timer.
    clearTimeout(this.idleTimer);
    // Start a new idle timer.
    this.idleTimer = setTimeout(() => {
      // User has been idle for the specified threshold.
      this.isIdle = true;
      if(data){
        this.getSuggestionFromDb(data);
      }
    }, this.idleThreshold);
  }

  getSuggestionFromDb(textObj:any) {
    var currObj = this;
    this.service.getChatbotInformation(textObj).subscribe((res: any) => {
          this.typing = 0;
          if (typeof res == "object") {
            res = res;
            this.botMsg = res;
            // this.typing = 1;
            setTimeout(() => {
              if(this.viewAns != 'viewAns'){
                currObj.searchName = res;
              }
              else{
                currObj.searchName = []
              }
              var search = this.searchName
              currObj.tempSearchName = search
              currObj.typing = 0;
            }, 1000);
            
          }
          else {
            //  this.checkCondition(res)
            let Obj: any = {}
            Obj["msg"] = "NA_"
            Obj["result"] = res
            this.botMsg = res;
            this.typing = 1;
            setTimeout(() => {
              currObj.searchName = []
              currObj.searchName.push(Obj);
              this.typing = 0;
            }, 1000);
          }
        })
  }

  searchResult: any = ''
  searchStatus: boolean = false
  searchData(name: any, result: any) {
    this.searchName = [];
    this.tempSearchName = []
    this.searchStatus = true
    this.text = ''
    var obj = { 'msg': name, 'type': 'UR' };
    this.botObj.push(obj);
    this.searchResult = result
    this.checkCondition(result)
  }

  backspaceClicked() {
    if(this.text == ''){
      this.viewAns = "viewAns"
    }
    this.searchName = []
  }

  // clickFaq: boolean = false
  click(i: any, data: any) {
    // this.clickFaq = true
    // this.service.setCondition(this.clickFaq);

    if (this.accrdReadStatus[i] == true) {
      this.accrdReadStatus[i] = false
    }
    else {
      this.accrdReadStatus = []
      for (let i = 0; i < data.length; i++) {
        this.accrdReadStatus.push(false)
      }
      this.accrdReadStatus[i] = true
      this.botMsg1 = ''
      i = i + 1
    }
  }

  onValChange(e:any){
    sessionStorage.setItem('locale', e.target.value)
    this.callBot()
  }
}
